import { render, staticRenderFns } from "./PurchasingPreApproval.vue?vue&type=template&id=dc31bb80&"
import script from "./PurchasingPreApproval.vue?vue&type=script&lang=js&"
export * from "./PurchasingPreApproval.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingPreApproval.vue?vue&type=style&index=0&id=dc31bb80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports